// extracted by mini-css-extract-plugin
module.exports = {"introVideo":"styles_introVideo__3GOhR"};